// extracted by mini-css-extract-plugin
module.exports = {"title":"Accordion_title__1uyke","titleTxt":"Accordion_titleTxt__n_plE","icon":"Accordion_icon__2D34i","panel":"Accordion_panel__2v09J"};